import { render, staticRenderFns } from "./DicaMetrica.vue?vue&type=template&id=2fb225ee&scoped=true&"
import script from "./DicaMetrica.vue?vue&type=script&lang=js&"
export * from "./DicaMetrica.vue?vue&type=script&lang=js&"
import style0 from "./DicaMetrica.vue?vue&type=style&index=0&id=2fb225ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb225ee",
  null
  
)

export default component.exports